
<template>
    <!-- <v-app id="searchZinn"> -->
    <v-main>
        <!-- <v-container fluid>   -->
        <v-card>
            <v-container fluid>
                <v-row dense cols="12" class="ml-4">
                    <h2>Accommodations sentences</h2>
                </v-row>
                <v-row dense cols="12" class="ml-4 subtextformat">Attention:   Amounts are not allowed in sentences. We have Acco / Additional costs for amounts. </v-row>

                <v-simple-table dense class="mt-6">
                    <tbody v-for="(zinnRecord, i) in searchZinn" :key="i">
                        <tr v-if="zinnRecord.zinn_groep != ''">
                            <td colspan="4"><h4>{{ zinnRecord.zinn_groep }}</h4></td>
                        </tr>
                        <tr @click="$router.reload('/syst/ref/zinn/onZinn/' + zinnRecord.zinn_encrid)">
                            <td>{{ zinnRecord.zinn_nr }}</td>
                            <td>{{ zinnRecord.zinn_docu }}</td>
                            <td v-if="zinnRecord.zinn_actief"></td>
                            <td v-else>inactive</td>
                            <td>{{ zinnRecord.zinntaal_oms }}</td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-container>
        </v-card>
        <!-- </v-container> -->
        <navBar title="Ares - Reference data" :home="true" type="referencedata"/>
    </v-main>
    <!-- </v-app> -->
</template>

<script>
    import navBar from "@/components/ui/navbars/navbar.vue";
    
    export default {
        components: {
            navBar
        },
        data() {
            return {
                searchZinn: []
            }  
        },
        mounted() {
            this.$axios.post("ares/json/ares/syst/ref/zinn/searchZinn.p", {
                header: {
                    token: this.$session.get("ARES"),
                    clientSessionId: this.$session.id(),
                    request: "searchZinn"
                },
                searchZinn: {
                }
            }).then(res => {
                if (res.data.error) {
                    console.log(res.data.error);
                } else {
                    this.searchZinn = res.data.searchZinn;
                }
            }).finally(() => {
                this.loading = false;
            });
        }
    };
</script>

<style scoped>
    .subtextformat{
        font-size: 14px !important;
        font-weight: 400;
        font-style: italic !important;
        color: orangered !important;
    }
</style>